export default "__VITE_ASSET__5oYpf9qY__"